<template>
  <div>
    <v-dialog fullscreen persistent v-model="dialog">
      <v-card tile :disabled="loading || loadingDelete">
        <BarTitle title="Medição MOP - Equipe" @close="dialog = false"></BarTitle>
        <!-- <v-card-actions>
          <v-spacer></v-spacer> -->
        <!-- <v-btn x-large color="primary" @click="dialog = false">salvar</v-btn> -->
        <!-- </v-card-actions> -->
        <!-- <v-divider></v-divider> -->
        <v-card-text>
          <v-card outlined class="mt-4">
            <v-data-table
              :loading="loading || loadingDelete"
              :disabled="loading || loadingDelete"
              :headers="headers"
              :items="filteredTeams"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Equipes</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchQuery"
                    append-icon="mdi-magnify"
                    label="Localizar"
                    single-line
                    hide-details
                    class="mr-8"
                    outlined
                    dense
                    rounded
                    @keyup="search"
                  ></v-text-field>
                  <v-spacer></v-spacer>

                  <v-btn rounded color="primary" @click="showNewTeam" dark class="mb-2"
                    ><v-icon small>mdi-plus</v-icon>Nova Equipe</v-btn
                  >
                </v-toolbar>
                <v-divider></v-divider>
              </template>
              <template v-slot:item.include="{ item }">
                <v-chip color="success" v-if="item.metering_mop.length > 0"
                  >Incluído</v-chip
                >
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip color="success" v-if="ifAppoved(item)">aprovado</v-chip>
              </template>

              <template v-slot:item.action="{ item }">
                <v-row>
                  <v-col class="text-right">
                    <span v-if="item.metering_mop.length == 0">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            :loading="item.loading"
                            :disabled="item.loading"
                            icon
                            color="success"
                            v-bind="attrs"
                            v-on="on"
                            @click="sendAddTeamMeteringMop(item)"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Adicionar Equipe da Medição</span>
                      </v-tooltip>
                    </span>
                    <span v-else>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-if="item.metering_mop.length > 0"
                            :loading="item.loadingRemove"
                            :disabled="item.loadingRemove"
                            icon
                            color="error"
                            v-bind="attrs"
                            v-on="on"
                            @click="sendRemoveTeamMeteringMop(item)"
                          >
                            <v-icon>mdi-minus</v-icon>
                          </v-btn>
                        </template>
                        <span>Remover Equipe da Medição</span>
                      </v-tooltip>
                    </span>
                    <span v-if="item.metering_mop.length > 0">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            color="secondary"
                            v-bind="attrs"
                            v-on="on"
                            @click="showManagerTeam(item)"
                          >
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>Rateio de Serviços</span>
                      </v-tooltip>
                    </span>


                    <span v-if="item.metering_mop.length > 0" >
                        <span v-if="!ifAppoved(item)">
                        <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                            :loading="item.loadingAproved"
                            :disabled="item.loadingAproved"
                            icon
                            color="success"
                            v-bind="attrs"
                            v-on="on"
                            @click="sendAproved(item)"
                            >
                            <v-icon>mdi-check</v-icon>
                            </v-btn>
                        </template>
                        <span>Aprovação</span>
                        </v-tooltip>
                        </span>
                        <span v-if="ifAppoved(item)">
                        <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                            :loading="item.loadingNotAproved"
                            :disabled="item.loadingNotAproved"
                            icon
                            color="error"
                            v-bind="attrs"
                            v-on="on"
                            @click="sendNotAproved(item)"
                            >
                            <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Não aprovar</span>
                        </v-tooltip>
                        </span>
                    </span>

                    <!-- <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="secondary"
                          v-bind="attrs"
                          v-on="on"
                          @click="$emit('select-team', item)"
                        >
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Visualizar Equipe</span>
                    </v-tooltip> -->
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          @click="editTeam(item)"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar Equipe</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="secondary"
                          v-bind="attrs"
                          v-on="on"
                          @click="showTeamHistoric(item)"
                        >
                          <v-icon>mdi-list-box</v-icon>
                        </v-btn>
                      </template>
                      <span>Hitorico da equipe</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="error"
                          v-bind="attrs"
                          v-on="on"
                          @click="deleteTeam(item)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Excluir Equipe</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <DialogMeteringMopAddTeam
      v-model="dialogNewTeam"
      :team="team"
      @refresh="refreshTeam"
    ></DialogMeteringMopAddTeam>
    <DialogMeteringMopManagerTeam
      v-model="dialogManagerTeam"
      :metering_mop_id="metering_mop_id"
      :team="team"
    ></DialogMeteringMopManagerTeam>
    <DialogMeteringMopTeamHistoric
       v-model="dialogManagerTeamHistoric"
       :team="team"
    >
    </DialogMeteringMopTeamHistoric>
  </div>
</template>

<script>
import BarTitle from "@/pages/Components/BarTitle.vue";
import DialogMeteringMopTeamHistoric from "./DialogMeteringMopTeamHistoric.vue";
import DialogMeteringMopAddTeam from "./DialogMeteringMopAddTeam.vue";
import DialogMeteringMopManagerTeam from "./DialogMeteringMopManagerTeam.vue";
import { mapActions } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    metering_mop_id: {
      type: Number,
      default: null,
    },
  },
  components: {
    BarTitle,
    DialogMeteringMopAddTeam,
    DialogMeteringMopManagerTeam,
    DialogMeteringMopTeamHistoric
  },
  data() {
    return {
      dialogManagerTeamHistoric: false,
      searchQuery: "",
      team: null,
      filteredTeams: [],
      loading: false,
      loadingDelete: false,
      dialogNewTeam: false,
      dialog: this.value,
      headers: [
        { text: "EQUIPE", value: "name" },
        { text: "", value: "include" },
        { text: "STATUS", value: "status" },
        { text: "", value: "action" },
      ],
      dialogManagerTeam: false,
      teams: [],
    };
  },
  watch: {
    value(newVal) {
      this.dialog = newVal;
      if (newVal) {
        this.teams = [];
        this.filteredTeams = [];
        this.loadTeams();
      }
    },
    dialog(newVal) {
      this.$emit("input", newVal);
    },
  },
  methods: {
    ...mapActions("MeteringMop", [
      "getTeams",
      "addTeamMeteringMop",
      "removeTeamMeteringMop",
      "destroyTeam",
      "approveTeam",
      "notApproveTeam",
    ]),
    /**
     * abre o dialogo para nova equipe
     */
    showNewTeam() {
      this.team = null;
      this.dialogNewTeam = true;
    },
    showTeamHistoric(item) {
      this.team = item;
      this.dialogManagerTeamHistoric = true;
    },

    editTeam(item) {
      this.team = item;
      this.dialogNewTeam = true;
    },
    deleteTeam(item) {
      this.loading = true;
      this.destroyTeam(item)
        .then(() => {
          this.$toast.success("Equipe excluída com sucesso!");
          this.loadTeams();
        }).catch((error) => {
          if (error.response.status === 423) {

            this.$toast.error("Não é possível excluir uma equipe vinculada a uma medição.");
          } else {
            this.$toast.error("Erro ao excluir equipe.");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * aprovar equipe
     */
    sendAproved(item){
        const data = {
          team_id: item.id,
          metering_mop_id: this.metering_mop_id,
        };
        item.loadingAproved = true;
        this.approveTeam(data)
        .then(() => {
            this.$toast.success("Equipe aprovada. ");
            item.metering_mop[0].pivot.status='approved';
            }).catch(() => {
             this.$toast.error("Erro ao aprovar equipe.");
        }).finally(() => {
            item.loadingAproved = false;
        });
    },
    /**
     * aprovar equipe
     */
    sendNotAproved(item){
        const data = {
          team_id: item.id,
          metering_mop_id: this.metering_mop_id,
        };
        item.loadingNotAproved = true;
        this.notApproveTeam(data)
        .then(() => {
            this.$toast.success("Equipe aprovada. ");
            item.metering_mop[0].pivot.status=null;
            }).catch(() => {
             this.$toast.error("Erro ao aprovar equipe.");
        }).finally(() => {
            item.loadingNotAproved = false;
        });
    },
    /**
     *verifica se a equipe esta aprovada
     */
    ifAppoved(item){
        if(item.metering_mop.length > 0){
            if(item.metering_mop[0].pivot.status=='approved'){
                return true;
            }
        }
        return false;
    },

    /**
     * carregar equipes
     */
    loadTeams() {
      this.loadingDelete = true;
      this.teams = []; // Limpa a lista de equipes
      this.getTeams(this.metering_mop_id)
        .then((response) => {
          this.teams = response.data;
          this.filteredTeams = response.data; // Inicializa a lista filtrada


        }).catch(() => {
          this.$toast.error("Erro ao carregar equipes.");
        }).finally(() => {
          this.loadingDelete = false;
        });
    },
    refreshTeam() {
      this.loadTeams();
      //    const index = this.teams.findIndex(t => t.id === team.id);
      //    if (index !== -1) {
      //      this.teams[index] = team;
      //    } else {
      //      this.teams.push(team);
      //    }
    },
    search() {
      const query = this.searchQuery.toLowerCase();
      this.filteredTeams = this.teams.filter((team) =>
        team.name.toLowerCase().includes(query)
      );
    },
    // ifInclude(item) {
    //     console.log(,item.metering_mop)
    //     // Verifica se o item já está incluído na medição MOP
    //     return this.teams.some(team => team.metering_mop.length > 0);
    // },
    /**
     * Adiciona a equipe a medicao mop.
     */
    sendAddTeamMeteringMop(item) {
      const data = {
        team_id: item.id,
        metering_mop_id: this.metering_mop_id,
      };
      item.loading = true;
      this.addTeamMeteringMop(data)
        .then((response) => {

          item.metering_mop = [{id : response.data.metering_mop_id}];
          item.metering_mop[0].pivot = response.data
          this.$toast.success("Equipe associada a medição !");
        })
        .finally(() => {
          item.loading = false;
        });
    },
    sendRemoveTeamMeteringMop(item) {
      const data = {
        team_id: item.id,
        metering_mop_id: this.metering_mop_id,
      };
      item.loadingRemove = true;
      this.removeTeamMeteringMop(data)
        .then(() => {
          item.metering_mop = [];
          this.$toast.success("Equipe removida da medição !");
        }).catch(() => {
           this.$toast.error("Erro ao remover equipe da medição.");
        })
        .finally(() => {
          item.loadingRemove = false;
        });
    },
    showManagerTeam(team) {
      this.dialogManagerTeam = true;
      this.team = team;
    },
  },
};
</script>

<style scoped></style>
